import { useParams } from 'react-router-dom';
import PublicUserProfile from '../../PublicUserProfile/PublicUserProfile';

const HandymanDetails = () => {

    return <PublicUserProfile />
}

export default HandymanDetails;